import React, { useState } from "react";
import AuthLayout from "components/Layout/AuthLayout";
import { AuthCard } from "components/Card/AuthCard";
import RegisterPageStepOne from "./RegisterPageStepOne";
import RegisterPageStepTwo from "./RegisterPageStepTwo";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { useForm } from "react-hook-form";

export const REGISTER_STEP_ENUM = {
  STEP_1: "1",
  STEP_2: "2",
};

const RegisterPage = () => {
  const [step, setStep] = useState(REGISTER_STEP_ENUM.STEP_1);

  const {
    register: registerStep1,
    watch: watchStep1,
    setError: setErrorStep1,
    formState: {
      errors: errorsStep1,
      isDirty: isDirtyStep1,
      isValid: isValidStep1,
    },
    handleSubmit: handleSubmitStep1,
  } = useForm();

  const {
    register: registerStep2,
    watch: watchStep2,
    setValue: setValueStep2,
    formState: {
      errors: errorsStep2,
      isDirty: isDirtyStep2,
      isValid: isValidStep2,
    },
    handleSubmit: handleSubmitStep2,
  } = useForm();

  return (
    <AuthLayout>
      <AuthCard>
        <span className="text-wce-navy text-2xl font-medium mb-6 self-center">
          Register
        </span>
        <div className="flex items-center text-wce-navy mb-4">
          {step === REGISTER_STEP_ENUM.STEP_2 && (
            <AiOutlineArrowLeft
              size={20}
              className="cursor-pointer mr-4"
              onClick={() => setStep(REGISTER_STEP_ENUM.STEP_1)}
            />
          )}
          <span className="font-medium">Step {step} of 2</span>
        </div>
        {step === REGISTER_STEP_ENUM.STEP_1 ? (
          <RegisterPageStepOne
            register={registerStep1}
            watch={watchStep1}
            handleSubmit={handleSubmitStep1}
            errors={errorsStep1}
            setError={setErrorStep1}
            isDirty={isDirtyStep1}
            isValid={isValidStep1}
            setStep={setStep}
          />
        ) : step === REGISTER_STEP_ENUM.STEP_2 ? (
          <RegisterPageStepTwo
            register={registerStep2}
            watch={watchStep2}
            setValue={setValueStep2}
            handleSubmit={handleSubmitStep2}
            errors={errorsStep2}
            isDirty={isDirtyStep2}
            isValid={isValidStep2}
            watchStep1={watchStep1}
          />
        ) : (
          ""
        )}
      </AuthCard>
    </AuthLayout>
  );
};

export default RegisterPage;
